import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { httpRequest } from "../../redux/Action";
import { API_END_POINTS } from "../../api/ApiEndPonts";


const RouteTracker = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  const user = useSelector(
    (state) => state.apiReducer.userGetMe?.response?.data
  );

  useEffect(() => {
    try {
      const path = location.pathname;

      // ❌ LOGIN / PUBLIC ROUTES SKIP
      const skipRoutes = ["/user/login", "/user/signup"];

      if (skipRoutes.includes(path)) return;

      // ❌ USER LOGIN NAHI → TRACK NAHI
      if (!user?._id) return;

      const lastRoute = sessionStorage.getItem("lastRoute");

      // ❌ SAME ROUTE → SKIP
      if (lastRoute === path) return;

      sessionStorage.setItem("lastRoute", path);

      // ✅ TRACK API CALL
      dispatch(
        httpRequest({
          key: API_END_POINTS.trackUserRoute.KEY,
          data: {
            route: path,
          },
        })
      );

    } catch (err) {
      console.error("Tracking error", err);
    }
  }, [location.pathname, user]);

  return null;
};

export default RouteTracker;